module.exports = __webpack_public_path__ + "media/Footprints/Furniture-68506970.svg";